// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__26y6H","tab":"ProcedureTabs_tab__3j0gw"};